<template>
  <div class="login-wrapper" v-on:keyup.13="login(false)">
    <div id="arkemaLogin">
      <b-img :src="require('@/assets/arkema_logo2.png')" class="brand-img"></b-img>
    </div>

    <div class="login-form">
      <h2>{{ $t("auth.connection") }}</h2>
      <!-- traduction -->
      <span class="login-form-label">{{ $t("auth.login") }}</span>
      <!-- traduction -->
      <div
        class="wrap-input100 validate-input mb-2"
        data-validate="Username is required"
      >
        <input
          class="form-input"
          type="text"
          name="username"
          v-model="user.username"
        />
      </div>
      <span class="login-form-label">{{ $t("auth.password") }}</span>
      <!-- traduction -->
      <div class="" data-validate="Password is required">
        <input
          class="form-input"
          type="password"
          name="pass"
          v-model="user.password"
        />
      </div>
      <div class="login-form-misc flex-row-reverse">
        <div @click="showModal = true">
          <a href="#" class="txt3">{{ $t("auth.forgotPassword") }}</a>
          <!-- traduction -->
        </div>
      </div>
      <div class="login-form-actions mb-2">
        <b-button
          variant="primary"
          class="btn-login btn-append"
          @click="login(false)"
        >
          <span>{{ $t("auth.connectionOperation") }}</span>
          <div>
            <b-icon icon="arrow-right" aria-hidden="true"></b-icon>
          </div>
        </b-button>
        <!-- traduction -->
        <div class="form-actions-separator">{{ $t("auth.or") }}</div>
        <!-- traduction -->
        <b-button
          variant="outline-primary"
          class="btn-login"
          @click="login(true)"
        >
          {{ $t("auth.connectionArkemaOperation") }}
        </b-button>
        <!-- traduction -->
      </div>
    </div>
    <div class="app-version">
      V{{version}}
    </div>
    <!-- Modals -->
    <LoginModal :show="showModal" @close="showModal = false" />
  </div>
</template>

<script lang="ts">
import router from "@/router/index";
import Constants from "@/utils/Constants";
import { Component,Vue } from "vue-property-decorator";
type User = {
  username: string;
  password: string;
  remember: Boolean;
};

@Component({
  components: {
    LoginModal: () => import("@/components/Auth/LoginModal.vue"),
  },
})
export default class Login extends Vue {
  private showModal: boolean = false;
  public submitted: boolean = false;
  public loading: boolean = false;
  public isSso: boolean = false;
  private get version (){
    return this.$store.state.APP_VERSION;
  }
    

    private created() {
        if (this.$route.query.noty == "error") {
            this.sendNotificationError(this.$t("auth.errorInvalidCombination").toString());
        }
    }

  // get return url from route parameters or default to '/'
  public get returnUrl(): string {
    return this.$route.query.returnUrl?.toString() || "/";
  }
  public error: string = "";
  private user: User = {
    username: "",
    password: "",
    remember: false,
  };
  private regexPassword: RegExp = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{8,})$/;

  private async login(useSso: boolean = false) {
    this.$store.commit('changeHasBeenModified',false);
    if (useSso) {
      const resolved = this.$router.resolve({
        name: "SsoCallBack",
      });
      const baseUrl = (this.$api && this.$api.defaults.baseURL) || '';
      document.location.href = `${baseUrl}auth/authenticate?returnUrl=${
        document.location.origin
      }${resolved.href}?returnUrl=${ this.returnUrl }`;
      return;
    }
    if (this.user.password == "")
      this.sendNotificationError(this.$t("auth.errorEmptyPassword").toString());
    //else if(!this.regexPassword.test(this.user.password)) this.sendNotificationError('Your password must have at least 8 characters !');
    if (this.user.username == "")
      this.sendNotificationError(this.$t("auth.errorEmptyLogin").toString());
    this.submitted = true;
    // stop here if form is invalid
    if (!(this.user.username && this.user.password)) {
      return;
    }

    this.loading = true;

    this.$store
      .dispatch("login", {
        Login: this.user.username,
        Password: this.user.password,
        UseSso: useSso,
      })
      .then(
        (user) => {
          if(this.returnUrl.toLowerCase() !== '/bops/add' && this.returnUrl.toLowerCase().includes('/bops/')){
            this.$router.push({ path: this.returnUrl })
          }else {
            router.go(0);
          }

          // this.sendNotificationSuccess(
          //   this.$t("auth.welcome").toString() + " " + user.firstName
          // );
          //location.href = this.returnUrl;
          // this.$router.push({ path: this.returnUrl })
        },
        (error) => {
          this.error = error;
          if (error.response.status === 403) {
            this.sendNotificationError(
              this.$t("auth.errorAccountDisabled").toString()
            );
          } else {
            this.sendNotificationError(
              this.$t("auth.errorInvalidCombination").toString()
            );
          }
          this.loading = false;
        }
      );
  }

  private sendNotificationError(text: any): void {
    this.$notify({
      group: "globalError",
      type: "error",
      title: this.$t("auth.errorLogin").toString(),
      text: text,
      duration: Constants.DEFAULT_WAIT_ERROR_NOTIFICATIONS,
    });
  }

  private sendNotificationSuccess(text: any): void {
    this.$notify({
      group: "global",
      type: "success",
      title: this.$t("auth.successfullLogin").toString(),
      text: text,
    });
  }
}
</script>

<style lang="scss" scoped>
#arkemaLogin {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 2em;

  > img {
    max-height: 50px;
  }
}

.login-form {
  h2 {
    line-height: 2.5;
  }
}
.login-wrapper {
  position: relative;
  .app-version {
    position: absolute;
    right: 15px;
    bottom: 15px;
    font-size: 10px;
    font-weight: bold;
  }
}
</style>
